import React, { useState, useEffect } from 'react';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import { smGet } from './api.js';

export const STATUS_LABEL = { draft: 'Draft', running: 'Running', paused: 'Paused', completed: 'Completed' };

// The campaign the Content, Launch and Statistics tabs work on.
function CampaignPicker({ value, onChange, allowAll = false, refreshKey }) {
    const [list, setList] = useState([]);
    useEffect(() => {
        smGet('/campaigns').then(l => {
            setList(l);
            if (!value && !allowAll && l.length) onChange(l[0].id);
        }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshKey]);
    return (
        <TextField select size="small" label="Campaign" value={list.some(c => c.id === value) ? value : (allowAll ? '' : '')} onChange={e => onChange(e.target.value)} sx={{ minWidth: 360 }}>
            {allowAll && <MenuItem value="">All campaigns</MenuItem>}
            {list.map(c => <MenuItem key={c.id} value={c.id}>{c.name} · {STATUS_LABEL[c.status] || c.status} · {c.stats.people} people</MenuItem>)}
            {!list.length && !allowAll && <MenuItem value="" disabled>No campaigns yet: create one from an audience</MenuItem>}
        </TextField>
    );
}

export default CampaignPicker;
